import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';

@Injectable({
  providedIn: 'root',
})
export class NotificationActivityService {
  constructor(private readonly http: HttpClient) { }

  checkTourStatus(notificationType: string): Observable<{ response: { isTourTaken: boolean } }> {
    const url = environment.cva_url + API_ROUTES.NOTIFICATION_ACTIVITY + API_ROUTES.CHECK_TOUR_STATUS;
    return this.http.get<{ response: { isTourTaken: boolean } }>(`${url}/${notificationType}`);
  }

  setInitialTourTakenStatus(notificationType: string): Observable<{ response: { success: boolean } }> {
    const url = environment.cva_url + API_ROUTES.NOTIFICATION_ACTIVITY + API_ROUTES.SET_INITIAL_TOUR_STATUS;
    return this.http.post<{ response: { success: boolean } }>(`${url}/${notificationType}`, {});
  }
}
